import { Staff } from '@/types/person';
import { OptionType } from '@/ui/components/Form/Select/types';
import formatStaffName from '@/utils/formatStaffName';

const setStaffSelectValue = (staff: Staff): OptionType<string> => {
  const supervisor = staff.clinical_supervisor;

  return {
    label: formatStaffName({ staff, byLastName: true }),
    subLabel: supervisor ? `Supervisor: ${formatStaffName({ staff: supervisor })}` : null,
    value: staff.id
  };
};

export default setStaffSelectValue;
